import React from 'react';
import Spinner from '../spinner';
import { ProductImagePlaceholderProps } from '../interfaces';
import './ProductImagePlaceholder.scss';

const ProductImagePlaceholder: React.FC<ProductImagePlaceholderProps> = ({ loading, children }) => (
  <div className="image-placeholder">
    {loading ? <Spinner /> : children}
  </div>
);

export default ProductImagePlaceholder;
